import i18n from '../i18n';

// Map the active i18n language to a BCP-47 locale for Intl date formatting.
// European day-month-year ordering is kept across all three locales.
const INTL_LOCALES = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' };

const intlLocale = () => INTL_LOCALES[i18n.language] || INTL_LOCALES.fr;

// Locale-aware date formatter. Reads the active locale at call time, so dates
// reformat when the language changes (callers re-render via react-i18next).
export const formatDate = (dateString, options) =>
  new Date(dateString).toLocaleDateString(intlLocale(), options);

/**
 * A `YYYY-MM-DD` day, read as a local day. `new Date('2026-09-01')` is **UTC** midnight, which a
 * browser west of Greenwich renders as the 31st of August — the one-day drift a `DATE` column
 * exists to avoid, re-introduced on the last mile.
 * @param {string} isoDay - A `YYYY-MM-DD` day.
 * @returns {string} The day, in the active locale.
 */
export const formatDay = (isoDay) => formatDate(`${isoDay}T00:00:00`);

export const formatDateTime = (dateString, options) =>
  new Date(dateString).toLocaleString(intlLocale(), options);

/**
 * Day and time without the year — `13/07 09:12` — for a dense column where the year is noise and
 * every row is recent anyway.
 *
 * Locale-aware like its two neighbours rather than a fixed `DD/MM`: `en-GB` is already the English
 * mapping above, so the day still leads, and a future locale that puts the month first gets it
 * right on its own instead of reading a French order as an American one.
 * @param {string} dateString - An ISO timestamp.
 * @returns {string} The day and the time, in the active locale.
 */
export const formatDayTime = (dateString) =>
  new Date(dateString).toLocaleString(intlLocale(), {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
